"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChoiceComponent = createChoiceComponent;
const vue_strict_prop_1 = __importDefault(require("vue-strict-prop"));
const tsx = __importStar(require("vue-tsx-support"));
const maybe_1 = require("@codegrade/maybe");
const utils_1 = require("@codegrade/utils");
const utils = __importStar(require("@/utils"));
const Fieldset_1 = require("./Fieldset");
const Option_1 = require("./Option");
const OptionDivider_1 = require("./OptionDivider");
const shared = __importStar(require("./shared"));
function getInputRefName(index) {
    return `input-${index}`;
}
function createChoiceComponent({ name, isEqual, renderOptionInput, }) {
    return tsx.componentFactoryOf().create({
        name,
        props: {
            ...shared.commonProps,
            value: vue_strict_prop_1.default.ofType().required,
            options: vue_strict_prop_1.default.ofRoArray().default(() => []),
        },
        data() {
            return {
                internalName: this.name ?? `${name}-name-${utils.getUniqueId()}`,
            };
        },
        computed: {
            isEveryOptionHidden() {
                return this.options.filter(o => o.tag === 'option').every(option => option.hidden);
            },
        },
        methods: {
            renderOption(optionData, index) {
                const { value, hidden } = optionData;
                if (hidden === true) {
                    return utils.emptyVNode();
                }
                const checked = isEqual(this.value, value);
                return (<Option_1.Option optionData={optionData} class={this.optionClasses} variant={this.variant} checked={checked} fieldsetDisabled={this.disabled} fieldsetReadonly={this.readonly} labelClass={this.optionLabelClass} scopedSlots={{
                        inputs: data => renderOptionInput.call(this, {
                            checked,
                            currentValue: this.value,
                            descriptionId: optionData.description != null
                                ? data.descriptionId
                                : undefined,
                            emitInputEvent: this.emitInputEvent,
                            name: this.internalName,
                            optionData,
                            ref: getInputRefName(index),
                        }),
                    }}/>);
            },
            emitInputEvent(newValue) {
                tsx.emitOn(this, 'onInput', newValue);
                this.options.forEach((option, index) => {
                    if (option.tag === 'divider') {
                        return;
                    }
                    maybe_1.Maybe.fromNullable(utils.getRefAsElement(this.$refs[getInputRefName(index)]))
                        .filter(el => el instanceof HTMLInputElement)
                        .ifJust($input => {
                        $input.checked = isEqual(this.value, option.value);
                    });
                });
            },
        },
        render() {
            if (this.isEveryOptionHidden) {
                return utils.emptyVNode();
            }
            return (<Fieldset_1.Fieldset legend={this.legend} disabled={this.disabled} variant={this.variant} description={this.description} legendClasses={this.legendClasses} optionsWrapperClasses={this.optionsWrapperClasses}>
                    {this.options.map((data, index) => utils_1.expr.match(data, 'tag', {
                    divider: () => <OptionDivider_1.Divider />,
                    option: optionData => this.renderOption(optionData, index),
                }))}
                </Fieldset_1.Fieldset>);
        },
    });
}
